import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/analytics";

export default function RouteAnalytics() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(pathname, { search: search || undefined });
  }, [pathname, search]);

  return null;
}
